import { Injectable } from '@angular/core';
import { Client } from '@microsoft/microsoft-graph-client/lib/src/Client';
import { SecurityService } from './security.service';
import { SsoSecurityService } from './sso-security.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class GraphService {
  // private graphClient: Client;
  // constructor() {
   
  
  // }

  // init(token){
  // //Initialize the Graph client
  // this.graphClient = Client.init({
  //   authProvider: async (done) => {
  //     // Get the token from the auth service
  //     if (token)
  //     {
  //       done(null, token);
  //     } else {
  //       done("Could not get an access token", null);
  //     }
  //   },
  //    baseUrl:"https://graph.microsoft.com/",
  //    defaultVersion:"beta"
  // });
  // }
  // async getProfile(): Promise<string> {
  //   try {
  //     let result =  await this.graphClient
  //       .api('/me/')
  //       .select('onPremisesUserPrincipalName')
  //       // .orderby('createdDateTime DESC')
  //       .get();
     
      
  //     return result.onPremisesUserPrincipalName;
  //   } catch (error) {
  //      console.log(error)
  //   }
  // }

  // async getUserProfile(upn): Promise<string> {
  //   try {
  //     let result =  await this.graphClient
  //       .api('/users/'+upn)
  //       .select('onPremisesUserPrincipalName')
  //       // .orderby('createdDateTime DESC')
  //       .get();
         
  //     return result.onPremisesUserPrincipalName;
  //   } catch (error) {
 
  //     throw new error;
  //      console.log(error)
  //   }
  // }

  private graphClient: Client;
  constructor(
    public authService: SsoSecurityService,private userservice:UserService) {
   
    //Initialize the Graph client
    this.graphClient = Client.init({
      authProvider: async (done) => {
        // Get the token from the auth service
        let token = await this.authService.accessToken()
          .catch((reason) => {
            done(reason, null);
          }
          );

        if (token)
        {
          done(null, token);
        } else {
        
          done("Could not get an access token", null);
        }
      },
       baseUrl:"https://graph.microsoft.com/",
       defaultVersion:"beta"
    });
  }
count=0;
  async getProfile(): Promise<String> {
    try {
      this.count++;
      let result =  await this.graphClient
        .api('/me/')
        //.select('onPremisesSamAccountName')
        // .orderby('createdDateTime DESC')
        .get();
      this.userservice.setObject("onPremisesSamAccountName",result.onPremisesSamAccountName);
      this.userservice.setObject("userPrincipalName",result.userPrincipalName);
      
      return result.userPrincipalName;
    } catch (error) {
      if(this.count<2){
         this.getProfile();
      }else{
        this.authService.startAuthentication();
        console.log(error)
      }

       
    }
  }

  async getUserProfile(upn): Promise<Event[]> {
    try {
      let result =  await this.graphClient
        .api('/users/'+upn)
        //.select('onPremisesSamAccountName')
        // .orderby('createdDateTime DESC')
        .get();
         
      return result.onPremisesSamAccountName;
    } catch (error) {
     // this.errdialogservice.openSnackBar("User not exists in LCL",'close');
      throw new error;
       console.log(error)
    }
  }

  
}
